export const NewsReadingProgressBar = ({ progress }) => {
  return (
    <div className="fixed inset-x-0 top-0 z-[80] h-1 bg-transparent" data-testid="news-article-reading-progress-track">
      <div
        className="h-full origin-left bg-[#D4AF37] transition-transform duration-150"
        data-testid="news-article-reading-progress-bar"
        style={{ transform: `scaleX(${Math.max(0, Math.min(progress, 100)) / 100})` }}
      />
    </div>
  );
};